import React, { Component } from 'react';
import { message } from 'antd';
import {
  queryMaterialDatabaseInfo,
  queryMaterialDirectoryList,
  queryMaterialDocumentInfo,
  queryMaterialDocumentLog,
  querySaveMaterialDocument,
} from '@api/administrative/material';
import { queryAccountList } from '@api/core/user';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      databaseInfo: {},
      directoryList: [],
      documentInfo: {},
    };
  }

  componentDidMount() {
    const { uuid } = this.props.params;
    const { databaseUuid } = this.props.location.query;
    this.getDatabaseInfo(databaseUuid);
    this.getDirectoryList(databaseUuid);
    this.getAccountList();

    if (uuid !== 'new') {
      const params = { uuid };
      this.getDocumentInfo(params);
      this.getDocumentLog(params);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { uuid } = nextProps.params;
    const { databaseUuid } = nextProps.location.query;
    if (this.props.params.uuid !== uuid && uuid !== 'new') {
      const params = { uuid };
      this.getDocumentInfo(params);
      this.getDocumentLog(params);
    }
    if (this.props.location.query.databaseUuid !== databaseUuid) {
      this.getDatabaseInfo(databaseUuid);
      this.getDirectoryList(databaseUuid);
    }
  }

  handSubmit = item => {
    this.getDocumentSave(item);
  };

  // 资料库详情
  getDatabaseInfo = uuid => {
    queryMaterialDatabaseInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          databaseInfo: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 用户列表
  getAccountList = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          userList: res.data || [],
        });
      } else {
        message.err(res.message, 2.5);
      }
    });
  };

  // 资料详情
  getDocumentInfo = params => {
    queryMaterialDocumentInfo(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          documentInfo: res.data,
        });
      } else {
        message.err(res.message, 2.5);
      }
    });
  };

  // 资料目录列表
  getDirectoryList = databaseUuid => {
    queryMaterialDirectoryList({ databaseUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          directoryList: res.data,
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 操作日志
  getDocumentLog = params => {
    queryMaterialDocumentLog(params).then(res => {
      if (res.statusCode !== 200) {
        message.err(res.message, 2.5);
      }
    });
  };

  // 资料保存
  getDocumentSave = params => {
    this.setState({
      isSubmitting: false,
    });
    querySaveMaterialDocument(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.props.router.go(-1);
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  render() {
    const { userList, directoryList, databaseInfo, documentInfo, isSubmitting } = this.state;
    const { directoryUuid } = this.props.location.query;
    return (
      <div>
        {this.props.params.uuid === 'new' ? (
          <FormBase
            userList={userList}
            isSubmitting={isSubmitting}
            databaseInfo={databaseInfo}
            directoryList={directoryList}
            directoryUuid={directoryUuid}
            handSubmit={this.handSubmit}
          />
        ) : (
          <FormBase
            data={documentInfo}
            userList={userList}
            isSubmitting={isSubmitting}
            databaseInfo={databaseInfo}
            directoryList={directoryList}
            directoryUuid={directoryUuid}
            handSubmit={this.handSubmit}
          />
        )}
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/administrative/material/document/PageAdd.js